import { OptionKey } from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import { InputBase } from '@shared/forms/inputs/input-base.class';
import { CheckboxInput } from '@shared/forms/inputs/input-checkbox.class';
import { ExhibitionSettingModel } from '../customization.interfaces';

export const prepareConfirmationCheckboxes = (
  settings: ExhibitionSettingModel,
  termsTranslation: string
): InputBase<any>[] => {
  const linkTextOnly = termsTranslation.match(/<.*?>/);
  let finalText = `<span data-translation="confirmation.terms-conditions">${termsTranslation}</span>`;

  if (linkTextOnly) {
    const link = `<a href="${settings.termsUrl}" target="_blank">${linkTextOnly[0].slice(1, -1)}</a>`;
    finalText = `<span data-translation="confirmation.terms-conditions">${termsTranslation.replace(
      linkTextOnly[0],
      link
    )}</span>`;
  }

  const inputs = [
    new CheckboxInput({
      key: 'email',
      label: '',
      order: 1,
      translate: true,
      required: false,
      options: [
        {
          key: 'emailConfirmation',
          value: false,
          label: 'confirmation.email-confirmation',
          cssClass: '',
          required: true
        }
      ],
      cssClass: '',
      columns: {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
      }
    })
  ];

  if (settings.isTermsVisible) {
    inputs.push(
      new CheckboxInput({
        key: 'terms',
        label: '',
        order: 2,
        translate: false,
        required: false,
        options: [
          {
            key: OptionKey.TradeConditions,
            value: false,
            label: finalText,
            cssClass: '',
            required: settings.isTermsMandatory
          }
        ],
        cssClass: '',
        columns: {
          xs: 12,
          sm: 12,
          md: 12,
          lg: 12,
          xl: 12
        }
      })
    );
  }

  return inputs;
};
